<template>
    <div v-show="errorMessage" class="absolute error-msg">
<!--    <div v-show="errorMessage" class="absolute error-msg"-->
<!--        :style="{ width: width ? width : '50%' }">-->
        <span>{{ errorMessage }}</span>
    </div>
</template>

<script>
    export default {
        name: "CustomValidationMessage",

        props: {
            errorMessage: {
                type: String,
            },
            width: {
                type: String,
                default: null
            }
        },
    };
</script>

<style scoped lang="scss">
    .error-msg {
        min-width: 250px;
        opacity: 0.9;
        background-color: #E53935;
        border-radius: 8px;
        top: calc(100% + 10px);
        color: white;
        display: flex;
        padding: 8px;
        z-index: 99;

        &::after {
            border-left: 10px solid transparent;
            border-right: 10px solid transparent;
            border-bottom: 10px solid #E53935;
            content: "";
            left: 20px;
            position: absolute;
            bottom: 100%;
        }
    }
</style>
